import React, { PureComponent } from 'react';

import RaisedButton from 'material-ui/RaisedButton';

export default class TimeCharter extends PureComponent {

  state = {
    type: 'Mpp' // ['Mpp', 'Bulk']
  }

  changeType = (value = 'Mpp') => {

    if (value === this.state.type) {
      return false;
    }

    this.setState({type: value})
  }

  render() {
    let Component = require(`./${this.state.type}`).default;

    return (
      <div className='container'>
        <div className='row'>
          <div className='col-md-12 text-center m-v-1'>
            <RaisedButton
              label='MPP TONNAGE'
              primary
              onClick={() => this.changeType('Mpp')}
              style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
              buttonStyle={{ lineHeight: '25px', height: '25px' }}
              labelStyle={{ fontSize: '11px' }}
            />
            <RaisedButton
              label='BULK TONNAGE'
              primary
              onClick={() => this.changeType('Bulk')}
              style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
              buttonStyle={{ lineHeight: '25px', height: '25px' }}
              labelStyle={{ fontSize: '11px' }}
            />
          </div>
        </div>
        <Component />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/components/TimeCharter/index.js